const timePassedSinceDate = (dateString: string): string => {
  const currentDate: Date = new Date()
  const dateObject: Date = new Date(dateString)

  const timeDifference: number = currentDate.getTime() - dateObject.getTime()
  const days: number = Math.floor(timeDifference / (1000 * 60 * 60 * 24))
  const hours: number = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  const minutes: number = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60))

  if (days > 0) {
    return `${days}d ${hours}h ${minutes}min`
  } else if (hours > 0) {
    return `${hours}h ${minutes}min`
  }
  return `${minutes}min`
}

export default timePassedSinceDate
